module.exports = __webpack_public_path__ + "static/award5-2caf502270d76b8920c81b2c79eed423.png";